module.exports = __webpack_public_path__ + "img/flexibility.79fb5559.svg";